/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { GetDateByRangeProps } from "@packages/sdk";

import { spacing } from "../../../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../../lib/constants/emotionMediaQueries.constants";
import { useCommunityTotalsStatisticCards } from "./useCommunityTotalsStatisticsCards.emotion";

const containerStyle: Interpolation = {
  display: "none",
  [cssMediaQueryMinWidthTablet]: {
    display: "grid",
  },
  gap: spacing.m,
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  paddingBottom: spacing.l,
  paddingTop: spacing.l,
};

const container2ColsStyle: Interpolation = {
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
};
const container4ColsStyle: Interpolation = {
  [cssMediaQueryMinWidthTablet]: {
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  },
};

export type CommunityTotalsStatisticCardsProps = {
  id: number;
  range?: GetDateByRangeProps["range"] | "all";
};

export const CommunityTotalsStatisticCards = ({
  id,
  range = "all",
}: CommunityTotalsStatisticCardsProps) => {
  const { statisticCards } = useCommunityTotalsStatisticCards({
    id,
    range,
  });

  return (
    <div
      css={[
        containerStyle,
        statisticCards.length <= 2 ? container2ColsStyle : container4ColsStyle,
      ]}
    >
      {statisticCards}
    </div>
  );
};

CommunityTotalsStatisticCards.displayName = "CommunityTotalsStatisticCards";
